import React from 'react';
import CustomerContactInfoComp from './CustomerContactInfoComp';

const CustomerContactInfoAdditionalPhone = props => (
<CustomerContactInfoComp
  {...props}
  errorMessages={{
    'field_is_required': 'The alternative phone number field is required',
    'field_is_invalid': 'Your alternative phone number is invalid',
  }}
  label="Alternative Phone Number"
  name="additionalPhone"
  type="tel"
/>
);

export default CustomerContactInfoAdditionalPhone;
